/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
// material
import { 
  Form, Grid, GridSet, GridItem, Link, Group, Icon, 
  ToolTip, TextField, FileUploader 
} 
from '@insticator/insticator-ui'; // iui-material

//styles
import styles from './check_styles';
import injectSheet from 'react-jss';
import { validation } from '../../../../../../../utils/validation';
import { fetchCheckInformation } from '../../../../../../../state/thunks/account';

const formName = 'CHECK'

/* ========== ~~~~~~~~~~ CHECK ~~~~~~~~~~ ========== */
const Check = injectSheet(styles)((props) => {
  const dispatch = useDispatch()
  const { payments } = useSelector(state => state.account)

  const { checkUUID, details, setDetails, onFormChange, onFormFileUpload, onFormFileDiscard, editable, isSaveClicked } = props

  useEffect(() => {
    if(checkUUID) dispatch(fetchCheckInformation(checkUUID))
  },[checkUUID, dispatch])

  useEffect(() => {
    if(payments.check && checkUUID) setDetails(payments.check)
  }, [payments, checkUUID, setDetails])

  const isValid = name => !checkUUID ? (!isSaveClicked || validation[name].test.test(details[name])) : !editable || validation[name].test.test(details[name])

  const uploadFile = file => onFormFileUpload(file)

  const discardFile = () => onFormFileDiscard()

  return(
    <Form formName={formName} >
      <Grid klass={`check ${props.classes.check}`}>
        <GridSet align={`horizontal`} >
          <GridItem type={`full`}>
            <TextField 
              type={`text`} name={`payTo`} value={details.payTo} valid={isValid('payTo')} 
              formName={formName} placeholder={`Account name`} label={`Pay to`} required 
              handleChange={e => onFormChange('payTo', e.target.value)}
              disabled={!editable}
            />
          </GridItem>
        </GridSet>
        <GridSet align={`horizontal`} >
          <GridItem type={`full`}>
            <TextField 
              type={`text`} name={`paymentStreetAddress`} value={details.paymentStreetAddress} valid={isValid('paymentStreetAddress')} 
              formName={formName} placeholder={`Street address`} label={`Payment Address`} required 
              handleChange={e => onFormChange('paymentStreetAddress', e.target.value)}
              disabled={!editable}
            />
          </GridItem>
        </GridSet>
        <GridSet align={`horizontal`} >
          <GridItem>
            <TextField 
              type={`text`} name={`city`} value={details.city} valid={isValid('city')} 
              formName={formName} placeholder={`City`} label={`City`} required 
              handleChange={e => onFormChange('city', e.target.value)}
              disabled={!editable}
            />
          </GridItem>
          <GridItem>
            <TextField 
              type={`text`} name={`zipCode`} value={details.zipCode} valid={isValid('zipCode')} 
              formName={formName} placeholder={`Zip/Postal Code`} label={`Zip/Postal code`} required 
              handleChange={e => onFormChange('zipCode', e.target.value)}
              disabled={!editable}
            />
          </GridItem>
        </GridSet>
        <GridSet align={`horizontal`} >
          <GridItem>
            <TextField 
              type={`text`} name={`state`} value={details.state} valid={isValid('state')} 
              formName={formName} placeholder={`State`} label={`State`}required 
              handleChange={e => onFormChange('state', e.target.value)}
              disabled={!editable}
            />
          </GridItem>
          <GridItem>
            <TextField 
              type={`text`} name={`country`} value={details.country} valid={isValid('country')} 
              formName={formName} placeholder={`Country`} label={`Country`} required 
              handleChange={e => onFormChange('country', e.target.value)}
              disabled={!editable}
            />
          </GridItem>
        </GridSet>
        <GridSet align={`horizontal`} >
          <GridItem>
            <Group name={`upload-form valid-true`} >
                <span>
                  W9 Form <ToolTip align={`right`} action={`click`} 
                            content={<p>Please make sure you are uploading a file in PDF format (we currently do not support other file formats).</p>}>
                              <Icon name={`exclamation-circle`} />
                          </ToolTip>
                </span>
                <FileUploader disabled={!editable} uploadFile={uploadFile} discardFile={discardFile} 
                  maxSize={5000} supportedFileTypes={['application/pdf']} 
                  filePreviewText={details.w9FormUpdateDateTime}
                  fileName={details.w9FormName}
                  isValid={!checkUUID ? (!isSaveClicked || !!(details.w9FormName || details.w9Form)) : !editable || !!(details.w9FormName || details.w9Form)}
                />
                <Link name={'w9formlink'} text={details.w9FormLink ? 'Download your W9 Form' : 'Download W9 Form Template'} 
                  variant={`primary`} type={`external`} action={details.w9FormLink ? details.w9FormLink : 'https://www.irs.gov/pub/irs-pdf/fw9.pdf'} 
                  icon={`arrow-down`} iconRight disabled={!editable}
                />
            </Group>
          </GridItem>
        </GridSet>
    </Grid>
    </Form>
  );

})



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Check
